const STEP = 22;

export const SpineMotif = ({ className = "", count = 12 }) => {
  const h = count * STEP;
  return (
    <svg viewBox={`0 0 48 ${h}`} className={className} fill="none" aria-hidden="true" focusable="false">
      <path d={`M24 0 C 32 ${h * 0.3}, 16 ${h * 0.6}, 24 ${h}`} stroke="currentColor" strokeWidth="1" opacity="0.6" />
      {Array.from({ length: count }).map((_, i) => {
        const w = 12 + (i / count) * 10;
        const x = 24 + Math.sin((i / count) * Math.PI * 1.6) * 4;
        return <rect key={i} x={x - w / 2} y={i * STEP + 6} width={w} height="10" rx="5" stroke="currentColor" strokeWidth="1.2" />;
      })}
    </svg>
  );
};

export const SpineDivider = ({ className = "" }) => (
  <svg viewBox="0 0 240 16" className={className} fill="none" aria-hidden="true" focusable="false">
    <path d="M0 8 H240" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    {Array.from({ length: 9 }).map((_, i) => (
      <rect key={i} x={30 + i * 21} y="3" width="12" height="10" rx="4" stroke="currentColor" strokeWidth="1.2" fill="white" />
    ))}
  </svg>
);
